import React, { Component } from 'react';
import { connect } from 'react-redux';
import './Tutorials.css';
import SimpleTable from 'components/shared/table/SimpleTable';
import VideoModal from 'components/shared/modal/VideoModal';
import { getTutorials } from './store/selectors';
import { loadTutorialsRequest } from './store/actions';

class Tutorials extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showVideoModal: false,
      videoSrc: null,
    };
  }

  componentDidMount() {
    this.props.dispatch(loadTutorialsRequest());
  }

  handleTutorialClick = (index) => {
    this.setState({
      showVideoModal: true,
      videoSrc: this.props.tutorials[index].link,
    });
  };

  handleCloseModal = () => {
    this.setState({
      showVideoModal: false,
      videoSrc: null,
    });
  };

  render() {
    return (
      <div className="users">
        <div className="full-title">Tutorials</div>

        <div className="content-container">
          <SimpleTable
            className="users-table"
            headers={['NAME']}
            rows={this.mapTutorials(this.props.tutorials)}
            emptyMessage="No Tutorials"
            onRowSelected={this.handleTutorialClick}
          />
        </div>

        <VideoModal
          show={this.state.showVideoModal}
          videoSrc={this.state.videoSrc}
          onHide={this.handleCloseModal}
        />
      </div>
    );
  }

  mapTutorials(tutorials) {
    return tutorials.map((tutorial) => {
      return [<span className="h3">{tutorial.title}</span>];
    });
  }
}

export default connect((state) => {
  return {
    tutorials: getTutorials(state),
  };
})(Tutorials);



// WEBPACK FOOTER //
// ./src/components/admin/tutorials/Tutorials.js